import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';

import { MoveGroupToSpaceList } from './MoveGroupToSpaceList/MoveGroupToSpaceList';
import {
  MoveGroupToSpacePopupParams,
  useMoveGroupToSpacePresenter,
} from './MoveGroupToSpacePopup.presenter';

export const MoveGroupToSpacePopup: FC<ICommonPopupsProps<MoveGroupToSpacePopupParams>> = observer(
  (props) => {
    const { t } = useTranslation();
    const presenter = useMoveGroupToSpacePresenter(props);
    useClosePopupOnNavigation(props.popupInstance);

    return (
      <Popup
        title={t('space_moveto_space_screen')}
        isOpened={!!presenter.group}
        onClose={presenter.onClose}
      >
        <MoveGroupToSpaceList
          spaces={presenter.spaces}
          onSelectSpace={presenter.onSelectSpace}
        ></MoveGroupToSpaceList>
      </Popup>
    );
  }
);
